<template>
  <div class="empty_container">
    <img :src="empty" >
  </div>
</template>

<script>
import EmptyImg from '@/assets/images/empty.png'
export default {
  data() {
    return {
      empty:''
    }
  },
  created() {
    this.empty = EmptyImg
  }
}
</script>

<style lang="less" scoped>
.empty_container{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>